<!-- container for any CPU visual element
Implement ChildContext for any given visual element (p.ex. Input-Text, Input-Password, etc.)
-->

<ng-template #content >
  <div class="outer outer--width-{{childContext.outerWidth}}-col {{childContext.outerClass}}">
    <div class="inner input--width-{{childContext.innerWidth}}-col {{childContext.innerClass}}">
      <ng-container *ngTemplateOutlet="componentsTemplate ? componentsTemplate : defaultContent;context:childContext"></ng-container>
      <p [ngClass]="{'debug': showDebug(), 'debug--false': !showDebug(), 'formcontrolvalue': showDebug()}">{{formattedMessage}}</p>
    </div>
  </div>
</ng-template>

<ng-template #simpleContent>
  <ng-container *ngTemplateOutlet="componentsTemplate ? componentsTemplate : defaultContent;context:childContext"></ng-container>
  <p [ngClass]="{'debug': showDebug(), 'debug--false': !showDebug(), 'formcontrolvalue': showDebug()}">{{formattedMessage}}</p>
</ng-template>

<!-- default placeholder for derived CPU visual elements to be displayed in CPUs CustomComponent -->
<ng-template #defaultContent>
  <div class="debug--warning">
    <p>TODO: Implement me!</p>
    <p>Bye, sincerely your CustomComponent</p>
  </div>
</ng-template>

<!-- display CPU visual component -->
@if (!childContext.skipOuterInner) {
  <ng-container *ngTemplateOutlet="content;context:childContext"></ng-container>
}

@if (childContext.skipOuterInner) {
  <ng-container *ngTemplateOutlet="simpleContent;context:childContext"></ng-container>
}
